import classNames from 'classnames'
import React, { FC, ReactNode, useEffect, useState } from 'react'

import s from './GradientLiveBorder.scss'

export const GradientLiveBorder: FC<{
  paused: boolean
  children: ReactNode
  skin?: 'standard' | 'error' | 'disabled' | 'harmony'
}> = ({ paused, children, skin = 'standard' }) => {
  const [realPaused, setRealPaused] = useState(paused)

  useEffect(() => {
    !paused && setRealPaused(paused)
  }, [paused])

  return (
    <div className={s.container}>
      <div
        className={classNames(
          s.border,
          { [s.paused]: realPaused },
          { [s.errorBorder]: skin === 'error' },
          { [s.disabledBorder]: skin === 'disabled' },
          { [s.harmonyBorder]: skin === 'harmony' },
        )}
        onAnimationIteration={() => paused && setRealPaused(paused)}
      >
        {children}
      </div>
    </div>
  )
}
